import configureStore from "./components/util/configureStore";

const store = configureStore({});

export default store;
